import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.css']
})
export class TransactionDetailComponent {
  MessageID: any;


  constructor(private route: ActivatedRoute, 
    private router: Router) {
    this.route.paramMap.subscribe((params) => {
      this.MessageID = params.get('id')!=""?params.get('id'):"";
    });
    
  }
  
}
